module.exports = __webpack_public_path__ + "static/media/CC20-MB215-12.a9220c12.png";